import { videoGallery as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

export const TestData = {
  header: 'See what our team has to say.',
  head: 'See what our team has to say.',
  videos: [
    {
      metadata: {
        tags: [],
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: '3g4b24b0tvoz',
          },
        },
        id: '1eL8sgqw70EA3eHT3K4ox1',
        type: 'Entry',
        createdAt: '2023-01-25T21:17:57.488Z',
        updatedAt: '2023-03-06T19:32:09.586Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment',
          },
        },
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'videoGalleryVideo',
          },
        },
        locale: 'en-US',
      },
      fields: {
        videoReference: {
          metadata: {
            tags: [],
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: '3g4b24b0tvoz',
              },
            },
            id: '2KBRvDBwWaKLzZsP0PpMgh',
            type: 'Entry',
            createdAt: '2023-01-12T22:06:45.982Z',
            updatedAt: '2023-03-06T14:52:46.734Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment',
              },
            },
            revision: 6,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'video',
              },
            },
            locale: 'en-US',
          },
          fields: {
            name: 'Video Upload Placeholder',
            video_source: true,
            youTubeUrl: 'https://www.youtube.com/watch?v=oznr-1-poSU',
            videoUpload: {
              metadata: {
                tags: [],
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: '3g4b24b0tvoz',
                  },
                },
                id: 'e7WxAjgu2bcStz0lJxwkN',
                type: 'Asset',
                createdAt: '2023-01-12T22:03:53.583Z',
                updatedAt: '2023-01-12T22:03:53.583Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment',
                  },
                },
                revision: 1,
                locale: 'en-US',
              },
              fields: {
                title: 'Placeholder Video Upload',
                description: '',
                file: {
                  url: '//videos.ctfassets.net/3g4b24b0tvoz/e7WxAjgu2bcStz0lJxwkN/e02445f3527d480b3868407a59e87f6d/San_Francisco_Townhouses.mp4',
                  details: {
                    size: 16196052,
                  },
                  fileName: 'San_Francisco_Townhouses.mp4',
                  contentType: 'video/mp4',
                },
              },
            },
            posterImage: {
              metadata: {
                tags: [],
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: '3g4b24b0tvoz',
                  },
                },
                id: '20knY7RjhN5gx3eHzgkqm7',
                type: 'Asset',
                createdAt: '2023-01-12T22:06:33.510Z',
                updatedAt: '2023-01-12T22:06:33.510Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment',
                  },
                },
                revision: 1,
                locale: 'en-US',
              },
              fields: {
                title: 'Placeholder Image',
                description: 'temporary placeholder image',
                file: {
                  details: {
                    size: 14637580,
                    image: {
                      width: 5232,
                      height: 3737,
                    },
                  },
                  fileName: 'buy-a-yacht-market-sea-EVY.jpg',
                  contentType: 'image/jpeg',
                },
              },
            },
          },
        },
        videoIcon: {
          metadata: {
            tags: [],
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: '3g4b24b0tvoz',
              },
            },
            id: '20knY7RjhN5gx3eHzgkqm7',
            type: 'Asset',
            createdAt: '2023-01-12T22:06:33.510Z',
            updatedAt: '2023-01-12T22:06:33.510Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment',
              },
            },
            revision: 1,
            locale: 'en-US',
          },
          fields: {
            title: 'Placeholder Image',
            description: 'temporary placeholder image',
            file: {
              url: '/assets/textimageplaceholder.png',
              details: {
                size: 14637580,
                image: {
                  width: 5232,
                  height: 3737,
                },
              },
              fileName: 'buy-a-yacht-market-sea-EVY.jpg',
              contentType: 'image/jpeg',
            },
          },
        },
        videoSubject: 'Prima verterem',
        videoSubjectDetails: ['Real Estate Advisor', 'Engel & Völkers Denver'],
        muteVideo: true,
      },
    },
    {
      metadata: {
        tags: [],
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: '3g4b24b0tvoz',
          },
        },
        id: '6BqpTZ1F1zeeSVKzkMG2qu',
        type: 'Entry',
        createdAt: '2023-01-25T21:17:23.277Z',
        updatedAt: '2023-03-06T19:31:25.042Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment',
          },
        },
        revision: 3,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'videoGalleryVideo',
          },
        },
        locale: 'en-US',
      },
      fields: {
        videoReference: {
          metadata: {
            tags: [],
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: '3g4b24b0tvoz',
              },
            },
            id: '18htW0QJgB7StOB1xnjDAb',
            type: 'Entry',
            createdAt: '2023-01-12T22:00:04.188Z',
            updatedAt: '2023-01-13T03:29:29.196Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment',
              },
            },
            revision: 4,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'video',
              },
            },
            locale: 'en-US',
          },
          fields: {
            name: 'YouTube Embed Placeholder',
            video_source: true,
            youTubeUrl: 'https://www.youtube.com/watch?v=oznr-1-poSU',
            posterImage: {
              metadata: {
                tags: [],
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: '3g4b24b0tvoz',
                  },
                },
                id: '20knY7RjhN5gx3eHzgkqm7',
                type: 'Asset',
                createdAt: '2023-01-12T22:06:33.510Z',
                updatedAt: '2023-01-12T22:06:33.510Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment',
                  },
                },
                revision: 1,
                locale: 'en-US',
              },
              fields: {
                title: 'Placeholder Image',
                description: 'temporary placeholder image',
                file: {
                  url: '/assets/textimageplaceholder.png',
                  details: {
                    size: 14637580,
                    image: {
                      width: 5232,
                      height: 3737,
                    },
                  },
                  fileName: 'buy-a-yacht-market-sea-EVY.jpg',
                  contentType: 'image/jpeg',
                },
              },
            },
          },
        },
        videoIcon: {
          metadata: {
            tags: [],
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: '3g4b24b0tvoz',
              },
            },
            id: '20knY7RjhN5gx3eHzgkqm7',
            type: 'Asset',
            createdAt: '2023-01-12T22:06:33.510Z',
            updatedAt: '2023-01-12T22:06:33.510Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment',
              },
            },
            revision: 1,
            locale: 'en-US',
          },
          fields: {
            title: 'Placeholder Image',
            description: 'temporary placeholder image',
            file: {
              url: '/assets/textimageplaceholder.png',
              details: {
                size: 14637580,
                image: {
                  width: 5232,
                  height: 3737,
                },
              },
              fileName: 'buy-a-yacht-market-sea-EVY.jpg',
              contentType: 'image/jpeg',
            },
          },
        },
        videoSubject: 'Causae definitiones',
        videoSubjectDetails: ['Real Estate Advisor', 'Engel & Völkers Denver'],
        muteVideo: true,
      },
    },
    {
      metadata: {
        tags: [],
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: '3g4b24b0tvoz',
          },
        },
        id: '3F2lPvrAmsAjpXFIWZvr4R',
        type: 'Entry',
        createdAt: '2023-01-25T21:17:07.613Z',
        updatedAt: '2023-01-25T21:17:07.613Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment',
          },
        },
        revision: 1,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'videoGalleryVideo',
          },
        },
        locale: 'en-US',
      },
      fields: {
        videoReference: {
          metadata: {
            tags: [],
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: '3g4b24b0tvoz',
              },
            },
            id: '2KBRvDBwWaKLzZsP0PpMgh',
            type: 'Entry',
            createdAt: '2023-01-12T22:06:45.982Z',
            updatedAt: '2023-03-06T14:52:46.734Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment',
              },
            },
            revision: 6,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'video',
              },
            },
            locale: 'en-US',
          },
          fields: {
            name: 'Video Upload Placeholder',
            video_source: true,
            youTubeUrl: 'https://www.youtube.com/watch?v=oznr-1-poSU',
            videoUpload: {
              metadata: {
                tags: [],
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: '3g4b24b0tvoz',
                  },
                },
                id: 'e7WxAjgu2bcStz0lJxwkN',
                type: 'Asset',
                createdAt: '2023-01-12T22:03:53.583Z',
                updatedAt: '2023-01-12T22:03:53.583Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment',
                  },
                },
                revision: 1,
                locale: 'en-US',
              },
              fields: {
                title: 'Placeholder Video Upload',
                description: '',
                file: {
                  url: '//videos.ctfassets.net/3g4b24b0tvoz/e7WxAjgu2bcStz0lJxwkN/e02445f3527d480b3868407a59e87f6d/San_Francisco_Townhouses.mp4',
                  details: {
                    size: 16196052,
                  },
                  fileName: 'San_Francisco_Townhouses.mp4',
                  contentType: 'video/mp4',
                },
              },
            },
            posterImage: {
              metadata: {
                tags: [],
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: '3g4b24b0tvoz',
                  },
                },
                id: '20knY7RjhN5gx3eHzgkqm7',
                type: 'Asset',
                createdAt: '2023-01-12T22:06:33.510Z',
                updatedAt: '2023-01-12T22:06:33.510Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment',
                  },
                },
                revision: 1,
                locale: 'en-US',
              },
              fields: {
                title: 'Placeholder Image',
                description: 'temporary placeholder image',
                file: {
                  url: '/assets/textimageplaceholder.png',
                  details: {
                    size: 14637580,
                    image: {
                      width: 5232,
                      height: 3737,
                    },
                  },
                  fileName: 'buy-a-yacht-market-sea-EVY.jpg',
                  contentType: 'image/jpeg',
                },
              },
            },
          },
        },
        videoIcon: {
          metadata: {
            tags: [],
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: '3g4b24b0tvoz',
              },
            },
            id: '20knY7RjhN5gx3eHzgkqm7',
            type: 'Asset',
            createdAt: '2023-01-12T22:06:33.510Z',
            updatedAt: '2023-01-12T22:06:33.510Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment',
              },
            },
            revision: 1,
            locale: 'en-US',
          },
          fields: {
            title: 'Placeholder Image',
            description: 'temporary placeholder image',
            file: {
              url: '/assets/textimageplaceholder.png',
              details: {
                size: 14637580,
                image: {
                  width: 5232,
                  height: 3737,
                },
              },
              fileName: 'buy-a-yacht-market-sea-EVY.jpg',
              contentType: 'image/jpeg',
            },
          },
        },
        videoSubject: 'Aliquip dissentias',
        videoSubjectDetails: ['Real Estate Advisor', 'Engel & Völkers Denver'],
        muteVideo: true,
      },
    },
    {
      metadata: {
        tags: [],
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: '3g4b24b0tvoz',
          },
        },
        id: '2SzqUpmXs8qPb3jIBCX4Za',
        type: 'Entry',
        createdAt: '2023-01-25T21:16:22.625Z',
        updatedAt: '2023-03-06T19:33:29.530Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment',
          },
        },
        revision: 2,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'videoGalleryVideo',
          },
        },
        locale: 'en-US',
      },
      fields: {
        videoReference: {
          metadata: {
            tags: [],
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: '3g4b24b0tvoz',
              },
            },
            id: '2KBRvDBwWaKLzZsP0PpMgh',
            type: 'Entry',
            createdAt: '2023-01-12T22:06:45.982Z',
            updatedAt: '2023-03-06T14:52:46.734Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment',
              },
            },
            revision: 6,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'video',
              },
            },
            locale: 'en-US',
          },
          fields: {
            name: 'Video Upload Placeholder',
            video_source: true,
            youTubeUrl: 'https://www.youtube.com/watch?v=oznr-1-poSU',
            videoUpload: {
              metadata: {
                tags: [],
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: '3g4b24b0tvoz',
                  },
                },
                id: 'e7WxAjgu2bcStz0lJxwkN',
                type: 'Asset',
                createdAt: '2023-01-12T22:03:53.583Z',
                updatedAt: '2023-01-12T22:03:53.583Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment',
                  },
                },
                revision: 1,
                locale: 'en-US',
              },
              fields: {
                title: 'Placeholder Video Upload',
                description: '',
                file: {
                  url: '//videos.ctfassets.net/3g4b24b0tvoz/e7WxAjgu2bcStz0lJxwkN/e02445f3527d480b3868407a59e87f6d/San_Francisco_Townhouses.mp4',
                  details: {
                    size: 16196052,
                  },
                  fileName: 'San_Francisco_Townhouses.mp4',
                  contentType: 'video/mp4',
                },
              },
            },
            posterImage: {
              metadata: {
                tags: [],
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: '3g4b24b0tvoz',
                  },
                },
                id: '20knY7RjhN5gx3eHzgkqm7',
                type: 'Asset',
                createdAt: '2023-01-12T22:06:33.510Z',
                updatedAt: '2023-01-12T22:06:33.510Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment',
                  },
                },
                revision: 1,
                locale: 'en-US',
              },
              fields: {
                title: 'Placeholder Image',
                description: 'temporary placeholder image',
                file: {
                  url: '/assets/textimageplaceholder.png',
                  details: {
                    size: 14637580,
                    image: {
                      width: 5232,
                      height: 3737,
                    },
                  },
                  fileName: 'buy-a-yacht-market-sea-EVY.jpg',
                  contentType: 'image/jpeg',
                },
              },
            },
          },
        },
        videoIcon: {
          metadata: {
            tags: [],
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: '3g4b24b0tvoz',
              },
            },
            id: '20knY7RjhN5gx3eHzgkqm7',
            type: 'Asset',
            createdAt: '2023-01-12T22:06:33.510Z',
            updatedAt: '2023-01-12T22:06:33.510Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment',
              },
            },
            revision: 1,
            locale: 'en-US',
          },
          fields: {
            title: 'Placeholder Image',
            description: 'temporary placeholder image',
            file: {
              url: '/assets/textimageplaceholder.png',
              details: {
                size: 14637580,
                image: {
                  width: 5232,
                  height: 3737,
                },
              },
              fileName: 'buy-a-yacht-market-sea-EVY.jpg',
              contentType: 'image/jpeg',
            },
          },
        },
        videoSubject: 'Lorem ipsum',
        videoSubjectDetails: ['Real Estate Advisor', 'Engel & Völkers Denver'],
        muteVideo: true,
      },
    },
  ],
};

export default fakeProps(schema, TestData);
